document.addEventListener('DOMContentLoaded', () => {
  const desktopOnly = window.matchMedia('(min-width: 990px)');
  const megaMenus = document.querySelectorAll('.header__inline-menu details.mega-menu');

  megaMenus.forEach((menu) => {
    const summary = menu.querySelector('summary');
    if (!summary) return;

    menu.addEventListener('mouseenter', () => {
      if (!desktopOnly.matches) return;

      document
        .querySelectorAll('.header__inline-menu details.mega-menu[open]')
        .forEach((openMenu) => {
          if (openMenu !== menu) {
            openMenu.removeAttribute('open');
          }
        });

      menu.setAttribute('open', '');
    });

    menu.addEventListener('mouseleave', () => {
      if (!desktopOnly.matches) return;
      menu.removeAttribute('open');
    });

    summary.addEventListener('click', (event) => {
      if (!desktopOnly.matches) return;
      event.preventDefault();
    });
  });

  window.addEventListener('resize', () => {
    if (!desktopOnly.matches) {
      document
        .querySelectorAll('.header__inline-menu details.mega-menu[open]')
        .forEach((menu) => menu.removeAttribute('open'));
    }
  });
});